import {
  chainBSC,
  chainBase,
  chainEth,
  chainBSCTestnet,
  chainUni,
} from "./eth";
import { chainSol, chainSolDevnet } from "./solana";
import { chainTon, chainTonDevnet } from "./ton";
import { chainSui, chainSuiDevnet } from "./sui";
import type { IChain } from "./types";

export const isMainnet = process.env.NEXT_PUBLIC_APP_ENV === "mainnet";

export * from "./types";

export {
  chainBSCTestnet,
  chainBSC,
  chainBase,
  chainEth,
  chainUni,
  chainSol,
  chainSolDevnet,
  chainTon,
  chainTonDevnet,
  chainSui,
  chainSuiDevnet,
};

export const AllChains: IChain[] = [
  chainBSCTestnet,
  chainBSC,
  chainBase,
  chainEth,
  chainUni,
  chainSol,
  chainSolDevnet,
];

// export const supportedChains: IChain[] = isMainnet
//   ? [chainSol, chainBSC, chainEth, chainBase, chainUni]
//   : [chainSolDevnet, chainBSCTestnet];
